import { defaultTo, equals, path, pipe, prop } from 'ramda';
import some from 'lodash/fp/some';
import sumBy from 'lodash/fp/sumBy';
import find from 'lodash/fp/find';
import { PAYMENT_TYPE } from '../../../../main/payment/constants';

export const getPayments = path(['register', 'payment', 'payments']);
const hasPaymentType = type => pipe(
  getPayments,
  some({ type }),
);
export const getHasCashPayment = hasPaymentType(PAYMENT_TYPE.cash);
export const getHasGiftCardPayment = hasPaymentType(PAYMENT_TYPE.giftCard);
export const getHasCardPayment = hasPaymentType(PAYMENT_TYPE.card);
export const getHasReaderPayment = hasPaymentType(PAYMENT_TYPE.reader);
export const getPaymentsTotal = pipe(
  getPayments,
  sumBy('amount'),
);

export const getIsGiftCardPayment = (state, id) => pipe(
  getPayments,
  find({ id }),
  defaultTo({}),
  prop('type'),
  equals(PAYMENT_TYPE.giftCard),
)(state);
